<form>
  <div class="d-flex flex-row justify-content-between">
    <div>
      @for (configuration of selection; track configuration) {
        <div>
          {{ configuration.name }} <button class="btn btn-sm btn-danger" (click)="remove(configuration)">X</button>
        </div>
      }
    </div>
    <div>
      <button class="btn btn-primary" type="submit" (click)="save()">{{ 'save' | translate }}</button>
    </div>
  </div>

  <app-datatable [dataSource]="organizationSource"
    [columns]=" columns"
    [defaultPageSize]="10"
    [actionNew]="false"
    (showEvent)="select($event.valueOf())">
    <app-empty-table [icon]="'groups'"
      [emptyText]="'organizations.empty_text' | translate">
    </app-empty-table>
  </app-datatable>

  <app-error [error]="error"></app-error>
</form>
